import React from 'react'

import Experiment from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { Locations } from '@mc/track-event'

import { GiftButton } from '../../components'
import { useGiftEnabled } from '../../lib/helpers'
import { GLOBAL_CTAS_PROMO_MODAL_FLAG_NAME } from './constants'

interface GlobalCtaModalExperimentProps {
  children: React.ReactNode
}

export const GlobalCtaModalExperiment = ({
  children,
}: GlobalCtaModalExperimentProps) => {
  const { giftEnabled } = useGiftEnabled()
  const { isPromotionOn } = usePromotion()

  if (!giftEnabled || !isPromotionOn) return children

  return (
    <Experiment
      name={GLOBAL_CTAS_PROMO_MODAL_FLAG_NAME}
      control={() => children}
      variant_1={() => (
        <div className='d-flex flex-column flex-gap-3'>
          {children}
          <GiftButton location={Locations.PROMOTION_MODAL} />
        </div>
      )}
    />
  )
}
